export default function watcherBtn(mapObj) {
	const {
		_id, _map, _maps, _listMarkers,
	} = mapObj;
	const btnList = document.querySelectorAll(`[data-open-map=${_id}]`);

	btnList.forEach((btn) => {
		btn.addEventListener("click", () => {
			document.querySelector("body").scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		});

		_maps.domEvent.manager.group(btn)
			.add(["click"], async () => {
				const { x, y, zoom } = btn.dataset;
				const marker = _listMarkers[`${x}-${y}`];
				const position = [parseFloat(x), parseFloat(y)];

				await _map.setCenter(position, zoom || 17, {
					checkZoomRange: true,
				});
				marker.balloon.open();
			});
	});
}
